import React, { useState, useEffect } from "react";
import { Prompt, useLocation, useHistory } from "react-router-dom";

const useNavigateAlertHook = () => {
  const [isDirty, setDirty] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (isDirty) return "Are you sure you want to discard changes?";
    };
    //Detecting browser closing below👇
    window.onbeforeunload = handleBeforeUnload;

    return () => {
      window.onbeforeunload = null;
    };
  }, [isDirty]);

  return [isDirty, setDirty];
};

export default useNavigateAlertHook;
